module.exports = __webpack_public_path__ + "static/media/hover-fat-boy.4c51a5e2.png";